import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Gallery from "../components/sections/Gallery";

const GalleryPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-pink-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-slate-800 mb-6">
              Our 
              <span style={{color: '#F8BBD9'}}> Beautiful</span>
              <span style={{color: '#A7C7E7'}}> Facilities</span>
            </h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Take a tour through our Georgian house with 2 acres of gardens, indoor play areas, and learning spaces designed for children aged 1-5 years.
            </p>
          </div>
        </section>
        
        <Gallery />
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;